import { bootstrapApplication } from '@angular/platform-browser';
import { Chart, registerables } from 'chart.js';
import { createAppConfig } from './app/app.config';
import { App } from './app/app';

Chart.register(...registerables);

bootstrapApplication(App, createAppConfig()).catch((err) =>
  console.error('Failed to start application:', err),
);
